import { atom } from 'recoil'

export const liveState = atom({
    key: 'liveState',
    default: 0,
});